import { useCallback, type FunctionComponent, type MouseEvent } from 'react';

import PinStrikethroughIcon from '@atlaskit/icon-lab/core/pin-strikethrough';
import PinIcon from '@atlaskit/icon/core/pin';
import { boardSwitcherSharedState } from '@trello/board-switcher';
import { Button } from '@trello/nachos/button';
import { Tooltip } from '@trello/nachos/tooltip';
import { useSharedStateSelector } from '@trello/shared-state';
import { useSplitScreenSharedState } from '@trello/split-screen';

import * as styles from './TogglePanelButton.module.less';

export const TogglePanelButton: FunctionComponent = () => {
  const currentMode = useSharedStateSelector(
    boardSwitcherSharedState,
    useCallback((state) => state.mode, []),
  );

  const { configuration: splitScreenConfiguration } =
    useSplitScreenSharedState();

  // TODO: i18n
  const modalLabel = 'Pin the board switcher to a panel';
  const panelLabel = 'Unpin the board switcher';

  const label = currentMode === 'panel' ? panelLabel : modalLabel;

  const onChange = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      const mode = currentMode === 'panel' ? 'modal' : 'panel';
      const layout = mode === 'panel' ? 'list' : 'grid';

      // TODO: Add analytics

      boardSwitcherSharedState.setValue({
        mode,
        layout,
      });
    },
    [currentMode],
  );

  // Don't render the settings button on small screens
  if (splitScreenConfiguration === 'tabs') {
    return null;
  }

  const icon =
    currentMode === 'panel' ? (
      <PinStrikethroughIcon label="" />
    ) : (
      <PinIcon label="" />
    );

  return (
    <div key="settings-button">
      <Tooltip
        content={label}
        hideTooltipOnClick
        isScreenReaderAnnouncementDisabled
      >
        <Button
          className={styles.button}
          onClick={onChange}
          aria-label={label}
          iconBefore={icon}
        />
      </Tooltip>
    </div>
  );
};
